import { Header, Paragraph } from "@datagame/ui";

import styles from "./MobileStickyBar.module.scss";

export interface MobileStickyBarProps {
  header: string;
  description: string;
  button: React.ReactNode;
}

export const MobileStickyBar = ({ header, description, button }: MobileStickyBarProps) => {
  return (
    <div className={styles.stickyBar}>
      <div className={styles.headerWrapper}>
        <Header variant="h6" className={styles.header}>
          {header}
        </Header>
        <Paragraph className={styles.description} size="xs">
          {description}
        </Paragraph>
      </div>
      {button}
    </div>
  );
};
